import { useCallback } from 'react'

import { CryptoCurrencyId, CryptoCurrencyStaticMeta } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { cryptoCurrenciesMetaSelector } from 'components/features/rewards/rewardsPane/store/selectors/currencies'
import { Collection } from 'interfaces'

function getCurrencyNameByIdOrNullAndStoreState (
  cryptoCurrencyIdOrNull: CryptoCurrencyId | null,
  cryptoCurrenciesMetaOrNull: Collection<CryptoCurrencyStaticMeta, 'id'> | null,
): string {
  if (!cryptoCurrencyIdOrNull || !cryptoCurrenciesMetaOrNull) {
    return ''
  }
  const currencyMetaOrUndefined = cryptoCurrenciesMetaOrNull.byKey[cryptoCurrencyIdOrNull]
  return currencyMetaOrUndefined?.name ?? '??'
}

export function useGetCryptoCurrencyNameById (cryptoCurrencyId: CryptoCurrencyId | null): string {
  const currenciesMetaOrNull = useStoreSelector(cryptoCurrenciesMetaSelector)
  return getCurrencyNameByIdOrNullAndStoreState(cryptoCurrencyId, currenciesMetaOrNull)
}

export function useGetCryptoCurrencyNameByIdCallback (): (cryptoCurrencyId: CryptoCurrencyId | null) => string {
  const currenciesMetaOrNull = useStoreSelector(cryptoCurrenciesMetaSelector)
  const getCurrencyNameCallback = useCallback((cryptoCurrencyId: CryptoCurrencyId | null) => (
    getCurrencyNameByIdOrNullAndStoreState(cryptoCurrencyId, currenciesMetaOrNull)
  ), [currenciesMetaOrNull])
  return getCurrencyNameCallback
}
